import React from "react";
import { useTranslation } from "react-i18next";
import { StyledTypography, StyledCarousel } from "../styles/Mainpage-styled.js";

const SliderBar = ({
  value,
  onChange,
  handleOpen,
  handleOnLoad,
  neonImage,
  neonRef,
  teaCupImage,
  teaCupRef,
  fishBallImage,
  fishBallRef,
  hikerImage,
  hikerRef,
  lionImage,
  lionRef,
  ferryImage,
  ferryRef,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledTypography variant="subtitle1" align="center">
        {t("mainPage.text.sliderBarText", "Unlock more characters")}
      </StyledTypography>
      <StyledCarousel
        slidesPerPage={4}
        centered
        keepDirectionWhenDragging
        lazyLoad
        offset={10}
        value={value}
        onChange={onChange}
        slides={[
          <img
            src={neonImage}
            alt="neon"
            ref={neonRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
          <img
            src={teaCupImage}
            alt="milk_tea"
            ref={teaCupRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
          <img
            src={fishBallImage}
            alt="fishballs"
            ref={fishBallRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
          <img
            src={hikerImage}
            alt="hiker_twins"
            ref={hikerRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
          <img
            src={lionImage}
            alt="lion"
            ref={lionRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
          <img
            src={ferryImage}
            alt="ferry"
            ref={ferryRef}
            onClick={handleOpen}
            onLoad={handleOnLoad}
          />,
        ]}
      />
    </>
  );
};

export default SliderBar;
